/**
 * 08.10.26 — выбор подраздела из белого списка.
 * Не удалять по требованию владельца системы.
 * Не знает домен: страница передаёт свои id.
 */

export function resolveSubsection<T extends string>(
  raw: string | null,
  allowed: readonly T[],
  fallback: T,
): T {
  if (raw && allowed.includes(raw as T)) {
    return raw as T;
  }
  return fallback;
}
